import { useCallback, useEffect, useRef, useState } from 'react';

export const useDebounce = (value: string, delay: number): string => {
  const [debouncedValue, setDebouncedValue] = useState(value);
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);

  return debouncedValue;
};

export const useRefDebounce = (delay = 1000) => {
  const timeoutRef = useRef<any>(null);
 
  const debounce = useCallback(
    // eslint-disable-next-line @typescript-eslint/ban-types
    (callback: Function) => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
 
      timeoutRef.current = setTimeout(() => {
        callback();
      }, delay);
    },
    [delay],
  );
 
  return debounce;
};